import { Controller } from "@hotwired/stimulus"

// Toggles membership field required state based on selected template type.
// For membership_agreement: required. For waiver: optional.
export default class extends Controller {
  static values = {
    templateTypes: Object  // { "1": "waiver", "2": "membership_agreement" }
  }

  static targets = [ "templateSelect", "membershipSelect" ]

  connect() {
    if (this.hasTemplateSelectTarget && this.hasMembershipSelectTarget) {
      this.templateSelectTarget.addEventListener("change", this.toggleMembership.bind(this))
      this.toggleMembership()
    }
  }

  toggleMembership() {
    const templateId = this.templateSelectTarget?.value
    const types = this.templateTypesValue || {}
    const agreementType = types[templateId]

    if (agreementType === "membership_agreement") {
      this.membershipSelectTarget.required = true
    } else {
      this.membershipSelectTarget.required = false
    }
  }
}
